import Creator from './Creator';
import ScreenshotImage from './ScreenshotImage';

const MAX_THUMBNAILS = 3;

const ItemCard = ({ item, badge, onView }) => {
  const thumbnails = item.screenshots.slice(0, MAX_THUMBNAILS);
  const hidden = item.screenshots.length - thumbnails.length;

  return (
    <button
      type="button"
      onClick={onView}
      className="group flex h-full w-full flex-col rounded-lg border bg-card text-left text-card-foreground shadow-sm transition-all hover:border-primary/60 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <div className="flex flex-1 flex-col gap-2 p-4">
        <div>{badge}</div>
        <div className="font-semibold leading-snug group-hover:text-primary">{item.title}</div>
        {item.description ? (
          <p className="line-clamp-3 whitespace-pre-wrap text-sm text-muted-foreground">{item.description}</p>
        ) : (
          <p className="text-sm italic text-muted-foreground/70">No description</p>
        )}
        {thumbnails.length > 0 && (
          <div className="mt-1 flex gap-2">
            {thumbnails.map((screenshot) => (
              <ScreenshotImage key={screenshot.object} screenshot={screenshot} className="h-16 w-24" />
            ))}
            {hidden > 0 && <div className="flex h-16 w-12 items-center justify-center rounded border bg-muted text-xs font-medium text-muted-foreground">+{hidden}</div>}
          </div>
        )}
      </div>
      <div className="border-t px-4 py-3">
        <Creator item={item} />
      </div>
    </button>
  );
};

export default ItemCard;
